import { render, staticRenderFns } from "./SweetAlertTest.vue?vue&type=template&id=08bed682&scoped=true"
import script from "./SweetAlertTest.vue?vue&type=script&lang=js"
export * from "./SweetAlertTest.vue?vue&type=script&lang=js"
import style0 from "./SweetAlertTest.vue?vue&type=style&index=0&id=08bed682&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bed682",
  null
  
)

export default component.exports